const now = () => new Date().toISOString();

const demoVehicles = [
  {
    id: "demo-vehicle-01",
    name: "Mobil Demo 01",
    plate: "B 1234 DEMO",
    imei: "DEMO000000000001",
    type: "car",
    lat: -6.1754,
    lng: 106.8272,
    speed: 32,
    direction: 90,
    acc: true,
    battery: 85,
    power: true,
    satellites: 12,
    accuracy: 5,
    gps_time: now(),
    server_time: now(),
    speed_limit: 80,
    supports_cutoff: false,
    immobilized: false,
    customer_name: "Customer Demo",
    expires_at: "2099-12-31",
  },
  {
    id: "demo-vehicle-02",
    name: "Motor Demo 02",
    plate: "B 5678 DEMO",
    imei: "DEMO000000000002",
    type: "motorcycle",
    lat: -6.1708,
    lng: 106.823,
    speed: 0,
    direction: 180,
    acc: false,
    battery: 75,
    power: true,
    satellites: 10,
    accuracy: 8,
    gps_time: now(),
    server_time: now(),
    speed_limit: 60,
    supports_cutoff: false,
    immobilized: false,
    customer_name: "Customer Demo",
    expires_at: "2099-12-31",
  },
];

const demoEvents = [
  {
    id: "demo-event-01",
    title: "Kendaraan bergerak",
    type: "movement",
    priority: "INFO",
    message: "Mobil Demo 01 mulai bergerak.",
    vehicle_id: "demo-vehicle-01",
    vehicle_name: "Mobil Demo 01",
    created_at: now(),
    acknowledged: false,
  },
  {
    id: "demo-event-02",
    title: "ACC OFF",
    type: "acc_off",
    priority: "INFO",
    message: "Kontak Motor Demo 02 dalam keadaan OFF.",
    vehicle_id: "demo-vehicle-02",
    vehicle_name: "Motor Demo 02",
    created_at: now(),
    acknowledged: false,
  },
];

const demoNotifications = demoEvents.map((event) => ({
  ...event,
  source: "vehicle",
  read: false,
}));

const demoGeofences = [
  {
    id: "demo-geofence-01",
    name: "Zona Demo Jakarta",
    latitude: -6.1754,
    longitude: 106.8272,
    lat: -6.1754,
    lng: 106.8272,
    center: [-6.1754, 106.8272],
    points: [],
    radius: 500,
    color: "#10B981",
    active: true,
    type: "circle",
  },
];

const demoUser = {
  id: "demo-user",
  name: "Pengguna Demo",
  email: "demo@glazytracker.local",
  role: "customer",
  is_demo: true,
  customer_id: "demo-customer",
  customer: {
    id: "demo-customer",
    name: "Armada Demo Glazy Tracker",
    company: "Glazy Tracker Demo",
    active: true,
  },
};

const positions = {};
const acknowledgedEvents = new Set();
const readNotifications = new Set();

function response(data, config) {
  return Promise.resolve({
    data,
    status: 200,
    statusText: "OK",
    headers: {},
    config,
    request: {},
  });
}

function getPath(config) {
  const raw = config.url || "";
  const withoutBase = raw.replace(/^.*\/api(?=\/|$)/, "");
  return withoutBase.split("?")[0] || "/";
}

function getParams(config) {
  return config.params || {};
}

function getVehicle(id) {
  return demoVehicles.find((v) => String(v.id) === String(id));
}

function makePositions(id) {
  if (!positions[id]) {
    const v = getVehicle(id);
    positions[id] = v
      ? Array.from({ length: 30 }, (_, i) => ({
          id: `demo-position-${id}-${i}`,
          vehicle_id: id,
          latitude: v.lat + i * 0.00015,
          longitude: v.lng + i * 0.00012,
          lat: v.lat + i * 0.00015,
          lng: v.lng + i * 0.00012,
          speed: i % 4 === 0 ? 0 : 25 + (i % 35),
          direction: 90,
          accuracy: 5,
          satellites: 10,
          gps_time: new Date(Date.now() - (29 - i) * 60000).toISOString(),
          server_time: new Date(Date.now() - (29 - i) * 60000).toISOString(),
          acc_status: true,
          ignition: true,
          battery: 85,
          power: true,
        }))
      : [];
  }
  return positions[id];
}

export async function demoAdapter(config) {
  const method = (config.method || "get").toLowerCase();
  const path = getPath(config);
  const params = getParams(config);
  const body = (() => {
    try {
      return typeof config.data === "string" ? JSON.parse(config.data) : config.data || {};
    } catch {
      return {};
    }
  })();

  // Identitas demo lokal; tidak menggunakan token atau akun produksi.
  if (path === "/auth/me") return response(demoUser, config);
  if (path === "/auth/logout") return response({ ok: true }, config);
  if (path === "/auth/preferences") return response({ ok: true }, config);

  if (path === "/vehicles" && method === "get") {
    // Pergerakan ilustratif untuk tampilan live tracking.
    demoVehicles.forEach((v, i) => {
      const step = (Date.now() / 2000 + i * 3) % 20;
      v.lat = (i === 0 ? -6.1754 : -6.1708) + Math.sin(step / 3) * 0.001;
      v.lng = (i === 0 ? 106.8272 : 106.823) + Math.cos(step / 3) * 0.001;
      v.gps_time = now();
      v.server_time = now();

      if (i === 0) {
        // Mobil bergerak dengan kecepatan simulasi yang berubah.
        v.speed = Math.round(20 + Math.abs(Math.sin(step)) * 35);
        v.acc = true;
      } else {
        // Motor tetap berhenti; posisi dan statusnya konsisten.
        v.speed = 0;
        v.acc = false;
      }
    });
    return response(demoVehicles, config);
  }

  if (path === "/dashboard") {
    return response({
      stats: { total: 2, online: 2, offline: 0, moving: 1, stopped: 1, alarm: 1 },
      recent_events: demoEvents,
    }, config);
  }

  if (path === "/events" && method === "get") {
    let items = demoEvents.filter((e) => !acknowledgedEvents.has(e.id));

    if (params.priority) {
      items = items.filter((e) => e.priority === params.priority);
    }
    if (params.type) {
      items = items.filter((e) => e.type === params.type);
    }
    if (params.vehicle_id) {
      items = items.filter((e) => String(e.vehicle_id) === String(params.vehicle_id));
    }
    if (params.acknowledged !== undefined) {
      const acknowledged = String(params.acknowledged) === "true";
      items = demoEvents.filter((e) =>
        acknowledgedEvents.has(e.id) === acknowledged
      );
      if (params.priority) items = items.filter((e) => e.priority === params.priority);
      if (params.type) items = items.filter((e) => e.type === params.type);
      if (params.vehicle_id) {
        items = items.filter((e) => String(e.vehicle_id) === String(params.vehicle_id));
      }
    }

    const counts = { CRITICAL: 0, WARNING: 0, INFO: 0 };
    demoEvents
      .filter((e) => !acknowledgedEvents.has(e.id))
      .forEach((e) => {
        if (counts[e.priority] !== undefined) counts[e.priority] += 1;
      });

    return response({ items, total: items.length, counts }, config);
  }

  if (path === "/events/ack-all" && method === "post") {
    demoEvents.forEach((e) => acknowledgedEvents.add(e.id));
    return response({ updated: demoEvents.length }, config);
  }

  const eventAck = path.match(/^\/events\/([^/]+)\/ack$/);
  if (eventAck && method === "post") {
    acknowledgedEvents.add(eventAck[1]);
    return response({ ok: true }, config);
  }

  if (path === "/notifications/unread-count") {
    return response({
      count: demoNotifications.filter((n) => !readNotifications.has(n.id)).length,
    }, config);
  }

  if (path === "/notifications" && method === "get") {
    let items = demoNotifications.map((n) => ({
      ...n,
      read: readNotifications.has(n.id),
    }));
    if (params.unread) items = items.filter((n) => !n.read);
    return response(items.slice(0, Number(params.limit) || 20), config);
  }

  if (path === "/notifications/read-all" && method === "post") {
    demoNotifications.forEach((n) => readNotifications.add(n.id));
    return response({ ok: true }, config);
  }

  const notificationRead = path.match(/^\/notifications\/([^/]+)\/read$/);
  if (notificationRead && method === "post") {
    readNotifications.add(notificationRead[1]);
    return response({ ok: true }, config);
  }

  if (path === "/geofences" && method === "get") {
    return response(demoGeofences, config);
  }

  if (path === "/geofences" && method === "post") {
    return response({ ...body, id: `demo-geofence-${Date.now()}` }, config);
  }

  const geofenceMatch = path.match(/^\/geofences\/([^/]+)(?:\/toggle)?$/);
  if (geofenceMatch && method !== "get") {
    return response({ ok: true, ...body }, config);
  }

  const vehicleMatch = path.match(/^\/vehicles\/([^/]+)(?:\/(positions|trips|commands|settings|command))?$/);
  if (vehicleMatch) {
    const [, id, action] = vehicleMatch;
    const vehicle = getVehicle(id);
    if (!vehicle) return response({ detail: "Kendaraan demo tidak ditemukan." }, config);

    if (!action && method === "get") return response(vehicle, config);
    if (action === "positions" && method === "get") return response(makePositions(id), config);
    if (action === "trips" && method === "get") return response([], config);
    if (action === "commands" && method === "get") return response([], config);
    if (action === "settings" && method === "put") return response({ ok: true }, config);

    // Semua perintah mesin ditolak dalam demo.
    if (action === "command") {
      return response({
        status: "simulated",
        simulated: true,
        message: "Perintah mesin tidak tersedia dalam mode demo.",
      }, config);
    }
  }

  if (path.startsWith("/reports/")) {
    const reportType = path.split("/")[2];
    const reportTitles = {
      mileage: "Daily Mileage",
      trips: "Trip Report",
      stops: "Stop Report",
      overspeed: "Overspeed Report",
      alarms: "Alarm Report",
      geofence: "Geofence Report",
      activity: "Vehicle Activity",
    };
    const columnsByType = {
      mileage: [
        { key: "date", label: "Tanggal", fmt: "text" },
        { key: "vehicle_name", label: "Kendaraan", fmt: "text" },
        { key: "distance_km", label: "Jarak (km)", fmt: "number" },
      ],
      trips: [
        { key: "date", label: "Tanggal", fmt: "text" },
        { key: "vehicle_name", label: "Kendaraan", fmt: "text" },
        { key: "distance_km", label: "Jarak (km)", fmt: "number" },
      ],
      stops: [
        { key: "date", label: "Tanggal", fmt: "text" },
        { key: "vehicle_name", label: "Kendaraan", fmt: "text" },
      ],
      overspeed: [
        { key: "date", label: "Tanggal", fmt: "text" },
        { key: "vehicle_name", label: "Kendaraan", fmt: "text" },
      ],
      alarms: [
        { key: "date", label: "Tanggal", fmt: "text" },
        { key: "vehicle_name", label: "Kendaraan", fmt: "text" },
      ],
      geofence: [
        { key: "date", label: "Tanggal", fmt: "text" },
        { key: "vehicle_name", label: "Kendaraan", fmt: "text" },
      ],
      activity: [
        { key: "date", label: "Tanggal", fmt: "text" },
        { key: "vehicle_name", label: "Kendaraan", fmt: "text" },
      ],
    };
    return response({
      title: reportTitles[reportType] || "Laporan Demo",
      columns: columnsByType[reportType] || [
        { key: "date", label: "Tanggal", fmt: "text" },
      ],
      rows: [],
      summary: { distance_km: 0 },
      items: [],
      data: [],
      demo: true,
    }, config);
  }
  if (path === "/push/config") return response({ enabled: false, vapid_public_key: null }, config);
  if (path === "/push/subscribe" || path === "/push/unsubscribe" || path === "/push/test") {
    return response({ ok: true, sent: 0 }, config);
  }

  if (path === "/auth/change-password") {
    return response({ detail: "Ganti kata sandi tidak tersedia dalam mode demo." }, config);
  }

  // Jangan pernah meneruskan endpoint yang belum disimulasikan ke server produksi.
  return response(
    { demo: true, read_only: true, message: "Fitur ini dibatasi dalam mode demo.", items: [], rows: [] },
    config,
  );
}
